export const gamification = {
    addRewardClass: true,
    authorizeExitUseOnlyShowNextButtonRules: true,
    avatarChoice: false,
    canExitRewardsDialog: false,
    defaultActiveTab: 'universes',
    exportAvatar: true,
    isOnboardingEnabled: false,
    isQuitButtonOnRewardsDialogAlwaysVisible: false,
    showRewardNavigateToAchievement: false,
};
